<template>
    <div>
        <br>
        <v-data-table :loading="loading" :headers="headers" :items="ItemIngredients.data" class="elevation-1" show-expand
            :expanded.sync="expanded" :single-expand="true" @click:row="dataTableRowClicked" hide-default-footer>
            <template v-slot:[`item.is_active`]="{ item }">
                <v-icon v-if="item.is_active == 1" color="success">
                    mdi-check-circle
                </v-icon>
                <v-icon v-else color="error"> mdi-close-circle </v-icon>
            </template>
            <template v-slot:no-data> No data </template>

            <template v-slot:[`item.actions`]="{ item }">
                <v-icon color="warning" class="mr-2" @click.stop="edit(item.id)">
                    mdi-pencil-box-outline
                </v-icon>
            </template>
            <template v-slot:[`item.price`]="{ item }">
                <b>{{ item.price | currency("", 0, { symbolOnLeft: false, }) }}</b>
            </template>

            <template v-slot:expanded-item="{ item }">
                <td :colspan="headers.length">
                    <v-row>
                        <v-col cols="12" class="mt-5">
                            <h4 class="mb-1">
                                Description : {{ item.description ? item.description : "N/A" }}
                            </h4>
                        </v-col>
                    </v-row>
                </td>
            </template>

            <template v-slot:top>
                <v-row dense class="mx-2">
                    <base-column :lg="4" :md="4" :sm="12">
                        <v-text-field v-model="search.search" append-icon="mdi-magnify" label="Search" outlined dense
                            hide-details></v-text-field>
                    </base-column>
                    <base-column :lg="8" :md="8" :sm="12">
                        <v-btn small color="darkblue" class="white--text" @click.stop="searching">Submit <v-icon
                                right>mdi-magnify</v-icon></v-btn>
                        <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
                            <v-icon right>mdi-close-circle-multiple </v-icon>
                        </v-btn>
                        <v-btn to="/master/item/tabs" small elevation="1" color="primary"
                            class="white--text float-end mx-2" @click="loader = 'loading3'">
                            Create
                            <v-icon right dark>mdi-plus-circle </v-icon>
                        </v-btn>
                    </base-column>
                </v-row>
                <v-spacer></v-spacer>
            </template>
        </v-data-table>
        <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
    </div>
</template>
  
  
<script>
import BaseColumn from "@/components/base/BaseColumn";
import { mapGetters, mapMutations } from "vuex";
export default {
    name: "ItemList",
    data() {
        return {
            headers: [
                { text: "Name", value: "name" },
                { text: "Unit", value: "unit.name" },
                { text: "Price", value: "price" },
                { text: "Action", value: "actions", sortable: false, width: 100 },
            ],
            page: 1,
            disabled: false,
            loading: false,
            status: ["Active", "Inactive"],
            search: {
                status: null,
                search: null,
                branch_id: null,
            },
            expanded: [],
            branch: [],
        };
    },

    created() {
        this.getItemIngredient();
        this.getBranch();
    },
    methods: {
        ...mapMutations("item_ingredient", ["CLEAR_STATE", "SET_ITEM_INGREDIENTS", "SET_ITEM_INGREDIENT", "SET_CURRENT_PAGE"]),
        async getItemIngredient() {
            this.loading = true;
            this.disabled = true;
            let params = {
                page: this.page,
                status: this.search.status,
                search: this.search.search,
                branch_id: this.search.branch_id,
            };

            await this.$axios
                .get("/master/ingredients", {
                    params: params,
                    headers: {
                        Authorization: this.$store.getters["auth/Token"],
                    },
                })
                .then(({ data }) => {
                    this.$store.commit("item_ingredient/SET_ITEM_INGREDIENTS", data.data.ingredient);
                    this.loading = false;
                    this.disabled = false;
                });
        },

        async getBranch() {
            await this.$axios
                .get("/master/branches", {
                    headers: {
                        Authorization: this.$store.getters["auth/Token"],
                    },
                })
                .then(({ data }) => {
                    this.branch = data.branch.data;
                });
        },

        searching() {
            this.page = 1;
            this.getItemIngredient();
        },
        clear() {
            this.page = 1;
            this.search = {
                status: "",
                search: "",
                branch_id: "",
            };
            this.getItemIngredient();
        },

        dataTableRowClicked(item) {
            if (item === this.expanded[0]) {
                this.expanded = [];
            } else {
                this.expanded = [item];
            }
        },

        async edit(id) {
            this.loading = true;
            await this.$axios
                .get("/master/ingredients/" + id, {
                    headers: {
                        Authorization: this.$store.getters["auth/Token"],
                    },
                })
                .then(({ data }) => {
                    this.SET_ITEM_INGREDIENT(data.data.ingredient);
                    this.loading = false;
                    this.$router.push("/item-ingredient/edit");
                })
                .catch(() => {
                    this.loading = true;
                });
        },
    },
    watch: {
        currentPage(newValue) {
            this.page = newValue;
            this.getItemIngredient();
        },
    },
    computed: {
        ...mapGetters("item_ingredient", {
            ItemIngredients: "ItemIngredients",
        }),

        ...mapGetters("auth", {
            ROLE: "Role",
        }),

        currentPage: {
            get() {
                return this.ItemIngredients.current_page;
            },
            set(val) {
                return this.$store.commit("item_ingredient/SET_CURRENT_PAGE", val);
            },
        },
        lastPage: {
            get() {
                return this.ItemIngredients.last_page;
            },
        },
    },

    components: {
        BaseColumn,
    },
};
</script>